/**
 * De merkkleuren als waarden, voor plekken waar geen Tailwind-klassen werken
 * (geprinte factuur, e-mail-HTML, canvas). MOET gelijk blijven aan
 * `tailwind.config.js` → theme.extend.colors en de :root-variabelen in index.css.
 *
 * Contrast (WCAG 2.1, zie docs/AUDIT-A11Y-SEO.md):
 * - ink, muted, clay en sage halen ≥ 4,5:1 als tekst op shell, sand en wit.
 * - rose is alleen voor tekst op ink (7,4:1), niet op lichte vlakken.
 * - sand, shell, blush en line zijn vlakken en lijnen, nooit tekstkleur.
 */
export const brandColors = {
  sand: '#f2ece4',
  shell: '#fcfaf7',
  ink: '#241f1c',
  muted: '#665a52',
  clay: '#8a5a45',
  rose: '#d8a396',
  blush: '#e9dcd2',
  sage: '#5f6b58',
  line: '#e0d6ca',
} as const
